import * as React from 'react';
import { Controller, useApi } from './useApi';

export interface Betreuerprovision {
    nr: number;
    abDat: string;
    provision: number;
    prov1: number;
    provWert1: number;
    prov2: number;
    provWert2: number;
    prov3: number;
    provWert3: number;
    prov4: number;
    provWert4: number;
}

export function useBetreuerprovisionList(): Betreuerprovision[] {
    const query = useApi<Betreuerprovision[]>(Controller.lookup + '/betreuerprovision', {});

    return React.useMemo<Betreuerprovision[]>(() => {
        if (query.isLoading || query.isError || !query.data) {
            return [];
        }
        return query.data;
    }, [query]);
}

export function useBetreuerprovisionListByNr(): { [key: number]: Betreuerprovision[] } {
    const betreuerprovisionList = useBetreuerprovisionList();

    return React.useMemo<{ [key: number]: Betreuerprovision[] }>(() => {
        return betreuerprovisionList.reduce<{ [key: number]: Betreuerprovision[] }>(
            (acc, betreuerprovision) => ({
                ...acc,
                [betreuerprovision.nr]: acc[betreuerprovision.nr]
                    ? [...acc[betreuerprovision.nr], betreuerprovision].sort((a, b) => a.abDat.localeCompare(b.abDat))
                    : [betreuerprovision],
            }),
            {},
        );
    }, [betreuerprovisionList]);
}
